module.exports = __webpack_public_path__ + "img/info-solid.198008b2.svg";